export default __webpack_public_path__ + "static/media/experimental_setup_poster.f6066e79.svg";